import { Box, H3, RichText } from "@engaging-tech/components"
import React from "react"

import { parseRichText } from "../../utils/richText"
import { formatTitle } from "./helpers"

const Title = ({ children, richTitle }) => {
  const parsedRichTitle = parseRichText(richTitle)

  return (
    <Box bg="dark.7" py={[2, 3]} px={3}>
      {parsedRichTitle ? (
        <Box textAlign="center">
          <RichText value={parsedRichTitle} openLinksInNewTab />
        </Box>
      ) : (
        <H3 fontSize={[3, 6]} textAlign="center" fontWeight="500">
          {formatTitle(children)}
        </H3>
      )}
    </Box>
  )
}

export default Title
